<template>
  <div class="VideoList">
    <my_title :content="title" ></my_title>
    <div class="v-list">
      <div v-for="v in videos" class="video">
        <my_video :v="v"></my_video>
        <div class="title">
          {{v.title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import MyTitle from '@/components/Title.vue';
 import MyVideo from '@/components/Video.vue';
 /* import ccV from '@/assets/video/CC_Game_Trailer_MP4_Final.mov';*/
 export default {
   name: 'VideoList',
   props: ['videos'],
   computed: {
     title() {
       return '比赛视频'
     },
   },
   components: {
     my_title: MyTitle,
     my_video: MyVideo
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .VideoList{
   width: 100vw;
   height: 29vw;
   /* background-image: url(~@/assets/image/frontpage/bg-video.png); */
   background-image: url('/oss/images/frontpage/bg-video.png');
   background-size: 100vw;
   display: flex;
   box-sizing: border-box;
   padding: 4.5vw;
   flex-direction: column;
   justify-content: space-between;
   align-items:center;

 }
 .v-list{
   display: flex;
   width: 80vw;
   align-items:center;
   justify-content:space-around;
 }
 .video{
   width: 19.8vw;
   height: 15.21vw;
   background-image: url(~@/assets/image/frontpage/video.png);
   background-size: 19.8vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   position: relative;
 }

 .title{
   margin-left: 3.4vw;
   display: flex;
   justify-content:center;
   align-items:center;
   width:16.98vw;
   height: 3.1vw;
   font-size: 1vw;
   color: white;
 }
</style>
